export default __webpack_public_path__ + "static/media/gournay13.a1d60b5f.jpg";